import { render, staticRenderFns } from "./tag-lv.vue?vue&type=template&id=a0443dae&scoped=true"
import script from "./tag-lv.vue?vue&type=script&lang=js"
export * from "./tag-lv.vue?vue&type=script&lang=js"
import style0 from "./tag-lv.vue?vue&type=style&index=0&id=a0443dae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0443dae",
  null
  
)

export default component.exports